export const MAX_TAB_TEMPLATE_NAME_LENGTH = 20;
export const MAX_TAB_TEMPLATE_DESCRIPTION_LENGTH = 85;
